$(function(){
    $('.card__title--toggle').on('click', function() {
        $(this).toggleClass('card__title--toggle--active');
        $(this).parent().find('.card__description').toggleClass('card__description--visible');
    });
});